export const usePromptSuggestions = () => {
  return {
    suggestions: [
      'Navigate to as many new screens as possible',
      'Sign in to this app',
      'Navigate to the contact page',
      'Complete this onboarding using random (valid) user details',
      'Checkout as a guest and return to the store',
    ],
  };
};
